import { render, staticRenderFns } from "./selectPass.vue?vue&type=template&id=05b025c9&scoped=true&"
import script from "./selectPass.vue?vue&type=script&lang=js&"
export * from "./selectPass.vue?vue&type=script&lang=js&"
import style0 from "./selectPass.vue?vue&type=style&index=0&id=05b025c9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b025c9",
  null
  
)

export default component.exports